<div class="m-0">
  <dialog-header headerClass="primary" 
                 title="{{'NO_PROCURATORY.TITLE' | translate}}"
                 hideCloseButton="true">
  </dialog-header>
  
  <div class="pt-8 px-16" fxLayout="column">

    <div class="pb-8" fxLayout="row" fxFlex="90">
      {{'NO_PROCURATORY.MESSAGE' | translate}}
    </div>

    <div class="py-8" fxLayout="row" fxLayoutAlign="end center">
      <button class="mr-16"
              mat-raised-button
              [matDialogClose]="false">{{'NO_PROCURATORY.DECLINE' | translate}}
      </button>
      <button mat-raised-button
              color="accent"
              [matDialogClose]="true"
              cdkFocusInitial>{{'NO_PROCURATORY.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</div>
